<template>
    <div v-if="cert_data != null">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <center>
            <!-- <v-btn class="button no-display" @click="exportToPDF">Export to PDF</v-btn> -->
            <!-- <v-btn class="button no-display" @click="downloadPdf">Export to PDF</v-btn> -->
            <!-- <v-btn class="button no-display" @click="generateReport11">Export to PDF</v-btn> -->

            <!-- <v-btn class="button no-display" @click="makePDF">Export to PDF</v-btn> -->

            <v-btn class="button no-display" @click="print"> Print </v-btn>
            <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
        </center>
        <template>
            <div v-if="show == true" ref="document" id="document1" class="printdiv">

                <div v-if="org_basic_data.school_name == 'Zeal International School'">
                    <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/zeal/CBSE+LETTERHEAD.jpg" alt=""
                        width="100%" />
                </div>
                <div class="header" v-else>
                    <v-row dense>
                        <v-col cols="12" sm="3" md="3">
                            <img :src="org_basic_data.trust_logo" alt="" class="schlImg" />
                            <span class="b-sapn h2-span" style="font-weight: 500; margin-left: 18px; font-size: 15px">
                                <b> UDISE No: {{ cert_data.udise_no }} </b>
                            </span>
                        </v-col>
                        <v-col cols="12" sm="9" md="9">
                            <center>
                                <h3 class="trust-name">{{ org_basic_data.trust_name }}</h3>
                                <h1 class="schl-name">{{ org_basic_data.school_name }}</h1>
                                <h3 style="text-transform: uppercase">(English Medium)</h3>
                                <span class="adrs">{{ org_basic_data.address }}</span><br />
                                <span class="adrs"> Ph.No. {{ org_basic_data.phone }} </span>
                                <span style="margin-left: 5px">
                                    Email: {{ org_basic_data.email }} </span><br />
                                <!-- <span class="line1" >{{org_basic_data.line1}}</span><br> -->
                                <span class="line1" v-html="org_basic_data.line1"></span><br />

                                <span class="line2" v-html="org_basic_data.line2"></span><br /><br />
                                <span class="stdsection">{{ cert_data.section_name }}</span>
                                <!-- <span class="stdsection">Primary Section</span> -->
                            </center>
                        </v-col>

                        <!-- <v-col cols="12" sm="9" md="9">
                                    <center>
                                        <h3 class="trust-name">{{org_basic_data.trust_name}}</h3>
                                    <h1 class="schl-name">{{org_basic_data.school_name}}</h1>
                                    
                                    </center>
                                    
                                    <center>
                                    <span class=" stretch">{{org_basic_data.address}}</span><br>
                                    
                                    <span class="stretch">
                                        Ph.No.(O) {{org_basic_data.phone}}
                                    </span>
                                    <span class="stretch" style="margin-left: 15%;">
                                        Email: {{org_basic_data.email}}
                                    </span>
                                    </center>
                                    <center>
                                    
                                    <span class="line1 stretch1">{{org_basic_data.line1}}</span><br />
                                   
                                    <span class="line2 stretch1" v-html="org_basic_data.line2"></span><br />
                                        </center>
                                    <span class="stdsection">{{cert_data.section_name}}</span><br />
                                    
                                    
            </v-col> -->
                    </v-row>
                </div>

                <div class="bonacontent">
                    <v-row dense>
                        <h1 class="bonaheading">Bonafide Certificate</h1>
                    </v-row>
                    <div class="container">
                        <!-- <span class="b-sapn">Outward No :- {{cert_data.outward_no}}</span><br> -->

                        <span class="h2-span">
                            General Register No.
                            <span style="font-weight: 600">:-&nbsp;{{ cert_data.gr_no }}</span>
                        </span>

                        <span class="h2-span" style="margin-left: 60px">
                            Academic Year
                            <span style="font-weight: 600">:-&nbsp;{{ cert_data.ay }}</span>
                        </span>
                        <span class="h2-span" style="margin-left: 50px; margin-bottom: 5px">
                            Sr. No.
                            <span style="font-weight: 600">:-&nbsp;{{ cert_data.cert_no }}</span> </span><br />
                        <br /><span class="b-span h2-span">This is to Certify that,</span><br />
                        <br /><span class="b-span h2-span">The details of Bonafide Student of this School are given
                            below.</span><br /><br />
                        <v-row dense>
                            <v-col cols="12" md="9" sm="9" class="col-md-9">
                                <span class="b-sapn">
                                    Student's Full Name
                                    <span class="name">:-&nbsp;{{ cert_data.stud_name }}</span> </span><br />
                                <span class="b-sapn">
                                    Standard & Division
                                    <span class="name">:-&nbsp;{{ cert_data.std }}</span>
                                    <span v-if="cert_data.div !== ''">
                                        <b> - {{ cert_data.div }} </b></span> </span><br />
                                <span class="b-sapn">
                                    D.O.B. (In Figure)
                                    <span class="name" style="margin-left: 63px">:-&nbsp;{{ cert_data.dob }}</span>
                                </span><br />
                                <span class="b-sapn">
                                    D.O.B. (In Words)
                                    <span class="name" style="margin-left: 62px">:-&nbsp;{{ cert_data.dob_words
                                        }}</span> </span><br />
                                <span class="b-sapn">
                                    Aadhar Card No.
                                    <span class="name" style="margin-left: 67px">:-&nbsp;{{ cert_data.aadhar }}</span>
                                </span><br />
                                <span class="b-sapn">
                                    Nationality
                                    <span class="name" style="margin-left: 106px">:-&nbsp;{{ cert_data.nationality
                                        }}</span> </span><br />
                                <span class="b-sapn">
                                    Place Of Birth
                                    <span class="name" style="margin-left: 86px">:-&nbsp;{{ cert_data.place_of_birth
                                        }}</span> </span><br />
                                <span class="b-sapn">
                                    Religion-Cast
                                    <span class="name" style="margin-left: 90px">:-&nbsp;{{ cert_data.religion }}-{{
                                        cert_data.caste
                                    }}</span> </span><br />
                                <span class="b-span h2-span">To the best of my knowledge he/she bears a good moral
                                    character.</span><br /><br />
                                <span class="b-sapn">
                                    Date
                                    <span class="name">:-&nbsp;{{ cert_data.cert_date }}</span> </span><br />
                                <span class="b-sapn">
                                    Place
                                    <span class="name" style="margin-left: 37px">:-&nbsp;{{ cert_data.place }}</span>
                                </span><br />
                            </v-col>
                            <v-col cols="12" md="3" sm="3" class="photo" v-if="cert_data.photo != null">
                                <img :src="awspath + cert_data.photo" alt="photostudent"
                                    style="height: 31%; width: 73%" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col></v-col>
                            <v-col cols="12" md="6" sm="6">
                                <center>
                                    <span class="h2-span">Principal</span><br />
                                    <span class="h2-span"> {{ org_basic_data.school_name }}</span>
                                    <!-- {{org_basic_data.school_name}}(Primary Section) -->
                                </center>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
            <!-- </v-card> -->
            <!-- modification code -->
            <br />
            <v-card class="box no-display">
                <div class="no-display" style="text-align: center">
                    ----------------------------------Modify------------------------------------
                </div>
                <br />
                <v-row class="no-display" justify="center">
                    <!-- <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Birth in words"
            v-model.trim="lc_data.dob_words"
          ></v-text-field>
        </v-col> -->

                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Standard" v-model.trim="cert_data.std"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Division" v-model.trim="cert_data.div"></v-text-field>
                    </v-col>
                </v-row>
            </v-card>
            <!-- modification code end -->
        </template>
    </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            snackbar: false,
            fetch_loader: false,
            gen_cert_loader: false,
            show_cert_loader: false,
            search: "",
            dialog: false,
            awspath: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            data_list: [],
            ay_std_div_list: null,
            sel_ay_data: null,
            cert_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            show: true,
            org_basic_data: [],
            htmlToPdfOptions: {
                margin: 0,

                filename: `hehehe.pdf`,

                image: {
                    type: "jpeg",
                    quality: 0.98,
                },

                enableLinks: false,

                html2canvas: {
                    scale: 1,
                    useCORS: true,
                },

                jsPDF: {
                    unit: "in",
                    format: "a4",
                    orientation: "landscape",
                },
            },
            progress: 0,
        };
    },
    watch: {
        progress(val) {
            this.$emit("progress", val);
        },
    },
    components: {
        VueHtml2pdf,
        // "pdf-content": PdfContent,
    },
    methods: {
        makePDF() {
            window.html2canvas = html2canvas;
            var doc = new jsPDF("p", "pt", "a4");
            doc.html(document.querySelector("#document1"), {
                callback: function (pdf) {
                    pdf.save("mypdf.pdf");
                },
            });
        },

        downloadPdf() {
            // var doc = new jsPDF();
            // doc.fromHTML(document.getElementById("document1"), 20,20,{'width':500});  //<-- not good. How can I refactor this?
            // doc.save("mypdf.pdf");
            var element = document.getElementById("document1");
            html2pdf(element, {
                jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
                filename: "myfile.pdf",
            });
        },

        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        close() {
            this.$router.push({ name: "get-Certificate-Report", target: "blank" });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        onload() {
            this.cert_data = JSON.parse(localStorage.getItem("cert_data"));
            this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
        },
        async exportToPDF() {
            console.log("hi");
            await html2pdf(this.$refs.document, {
                enableLinks: false,
                margin: 0,
                filename: "document.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 1, useCORS: true },
                jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
            });
            console.log("hi1");
        },
        generateReport() {
            this.beforeDownload();
            this.$refs.html2Pdf.generatePdf();
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages();
                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(10);
                        pdf.setTextColor(150);
                        pdf.text(
                            "Page " + i + " of " + totalPages,
                            pdf.internal.pageSize.getWidth() * 0.88,
                            pdf.internal.pageSize.getHeight() - 0.3
                        );
                    }
                })
                .save();
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.onload();
    },
};
</script>
<style scoped>
.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #fff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #ffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

.t-row {
    padding: 1rem i !important;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.delete-avatar {
    transition: 0.3s;
    border: 1px solid red;
    margin: 0.2rem !important;
}

.delete-avatar:hover {
    background-color: transparent;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 15px;
}

.delete-v-icon:hover {
    color: white;
}

.v-dialogss {
    bottom: 880;
    right: 0;
}

/* shiv css */
@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    .b-sapn {
        display: block;
        margin-top: 2px;
        font-size: larger;
    }

    .h2-span {
        font-size: larger;
    }

    /* img {
            width: 100% !important;
             } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"] {
        display: none !important;
    }

    .photo {
        width: 50% !important;
        height: 30% !important;
    }

    /* .printdiv{
               margin-top: none !important;
               padding-top: none !important;
           } */

    @page {
        size: A4;

        margin-top: -1%;
        /* padding-top: -1%; */

        /* size: 12in 15in; */

        size: 11in 14.5in;
        /* size: 11.5in 13in; */
    }

    /* .line1 {
    margin-left: -1%;
  } */

    * {
        overflow: hidden !important;
    }
}

.b-sapn {
    display: block;
    margin-top: 2px;
}

.name {
    margin-left: 44px;
    font-weight: 600;
}

.schlImg {
    /* width: 196px;
        height: 196px; */
    width: 87%;
    height: 60%;
    margin-left: 10px;
}

.printdiv {
    border: 3px solid;
    border-color: black;
    /* height: 1160px;  */
    height: auto;
    /*width: 944px;
        margin-left: 5%; */
    /* height: auto;  */
    width: auto;
    /* margin: 5%; */
    margin-left: 5%;
    margin-right: 5%;
}

.header {
    border: 2px solid;
    margin: 6px;
}

.trust-name {
    /* margin-left: 22%; */
    text-transform: uppercase;
}

.schl-name {
    font-size: 30px;
    text-transform: uppercase;
}

.adrs {
    margin-left: 33px;
}

.line1 {
    margin-left: 15px;
}

.line2 {
    margin-left: 22px;
}

.stdsection {
    /* margin-left: 22%; */
    font-weight: bold;
    text-transform: uppercase;
    font-size: 20px;
    /* margin-right: 17%; */
}

.bonaheading {
    border-bottom: 3px solid black;
    margin-left: 39%;
    line-height: 1em;
    margin-top: 1%;
    margin-bottom: 2%;
}

span.stretch {
    display: inline-block;
    -webkit-transform: scale(1.5, 1);
    /* Safari and Chrome */
    -moz-transform: scale(1.3, 1);
    /* Firefox */
    -ms-transform: scale(1.5, 1);
    /* IE 9 */
    -o-transform: scale(1.5, 1);
    /* Opera */
    /* transform: scale(1.3,1); */
    /* margin-left: 25%; */
    font-size: 14px;
}

.stretch1 {
    display: inline-block;
    -webkit-transform: scale(1.3, 1);
    /* Safari and Chrome */
    -moz-transform: scale(1.3, 1);
    /* Firefox */
    -ms-transform: scale(1.5, 1);
    /* IE 9 */
    -o-transform: scale(1.5, 1);
    /* Opera */
    /* transform: scale(1.3,1); */
    /* margin-left: 25%; */
    font-size: 14px;
}

/* shiv css end */
</style>
